import { useTranslation } from "react-i18next";

const features = [
  { icon: "ri-truck-line", key: "about_feature_1" },
  { icon: "ri-shield-check-line", key: "about_feature_2" },
  { icon: "ri-link-m", key: "about_feature_3" },
  { icon: "ri-customer-service-2-line", key: "about_feature_4" },
  { icon: "ri-verified-badge-line", key: "about_feature_5" },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-foreground-900">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <span className="text-xs font-semibold text-foreground-300 uppercase tracking-widest">
          {t("about_label")}
        </span>

        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight">
          {t("about_title_line1")}
          <br />
          {t("about_title_line2")}
          <br />
          {t("about_title_line3")}
        </h2>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 text-sm font-semibold text-foreground-900 bg-background-50 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>{t("about_btn_primary")}</span>
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 text-sm font-medium text-foreground-100 border border-foreground-500 hover:border-foreground-200 hover:text-foreground-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>{t("about_btn_secondary")}</span>
            <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.key}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-foreground-800/60 border border-foreground-700/30 hover:border-foreground-500/50 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${feat.icon} text-accent-400 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-200 whitespace-nowrap">
                {t(feat.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}